package com.iregained.site.components.sections.about.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

val AboutValuesContainerStyle = CssStyle.base {
    Modifier.fillMaxWidth()
        // Using a soft background color to make the white bento cards pop
        .backgroundColor(colorMode.toSitePalette().custom.lightGray)
}

val AboutValuesHeaderColumnStyle = CssStyle.base {
    Modifier.fillMaxWidth().maxWidth(1200.px).padding(leftRight = 24.px, bottom = 64.px)
}

val AboutValuesTitleStyle = CssStyle.base {
    Modifier.color(colorMode.toSitePalette().custom.darkText).fontSize(2.5.cssRem).fontWeight(FontWeight.Bold)
        .textAlign(TextAlign.Center).lineHeight(1.2).margin(bottom = 16.px)
}

val AboutValuesSubtitleStyle = CssStyle.base {
    Modifier.color(colorMode.toSitePalette().brand.primary).fontSize(1.125.cssRem).fontWeight(FontWeight.Medium).textAlign(TextAlign.Center)
        .lineHeight(1.6)
}

val AboutValuesGridStyle = CssStyle.base {
    Modifier.fillMaxWidth().maxWidth(1200.px).gap(32.px).padding(leftRight = 24.px)
}

val AboutValueCardStyle = CssStyle {
    base {
        Modifier.fillMaxWidth().height(100.percent) // Ensures all cards in the row stretch to equal height
            .backgroundColor(Colors.White).borderRadius(24.px) // Aggressive rounding for the modern "Bento" look
            .padding(40.px).boxShadow(0.px, 4.px, 24.px, color = Colors.Black.copy(alpha = 5))
            .transition(Transition.of("transform", 250.ms), Transition.of("box-shadow", 250.ms))
    }
    hover {
        // Physical tactile feedback when a user mouses over the card
        Modifier.transform { translateY((-8).px) }.boxShadow(0.px, 12.px, 32.px, color = Colors.Black.copy(alpha = 10))
    }
}

val AboutValueIconStyle = CssStyle.base {
    Modifier.size(56.px).margin(bottom = 24.px)
}

val AboutValueCardTitleStyle = CssStyle.base {
    Modifier.color(colorMode.toSitePalette().brand.primary).fontSize(1.5.cssRem).fontWeight(FontWeight.Bold)
        .margin(bottom = 16.px)
}

val AboutValueCardDescStyle = CssStyle.base {
    Modifier.color(colorMode.toSitePalette().custom.darkText.toRgb()).fontSize(1.cssRem)
        .lineHeight(1.6)
}